import { dateToReadableString } from 'utils'

export const columns = [
  {
    customWidth: 150,
    Header: () => 'WMS Order Number',
    accessor: 'WMSOrderNumber',
    Cell: ({ row }) => (
      <div className='flex min-w-[150px]'>{row?.original?.whOrderNo}</div>
    ),
  },
  {
    customWidth: 160,
    Header: () => 'Customer Reference',
    accessor: 'customerReference',
    Cell: ({ row }) => (
      <div className='flex min-w-[160px]'>
        {row?.original?.customerReference}
      </div>
    ),
  },
  {
    customWidth: 80,
    Header: () => 'Principle',
    accessor: 'principle',
    Cell: ({ row }) => (
      <div className='flex min-w-[80px]'>{row?.original?.principle}</div>
    ),
  },
  {
    customWidth: 220,
    Header: () => 'Suburb',
    accessor: 'suburb',
    Cell: ({ row }) => (
      <div className='flex min-w-[120px]'>{row?.original?.suburb}</div>
    ),
  },
  {
    customWidth: 220,
    Header: () => 'Courier',
    accessor: 'courier',
    Cell: ({ row }) => (
      <div className='flex min-w-[120px]'>{row?.original?.courier}</div>
    ),
  },
  {
    customWidth: 120,
    Header: () => 'Order Date',
    accessor: 'orderDate',
    Cell: ({ row }) => (
      <div className='flex min-w-[120px]'>
        {row?.original?.orderDate
          ? dateToReadableString(row?.original?.orderDate)
          : ''}
      </div>
    ),
  },
  {
    customWidth: 150,
    Header: () => 'Consignment Date',
    accessor: 'consignmentDate',
    Cell: ({ row }) => (
      <div className='flex min-w-[150px]'>
        {' '}
        {row?.original?.dispatchedDate
          ? dateToReadableString(row?.original?.dispatchedDate)
          : ''}
      </div>
    ),
  },
  {
    customWidth: 120,
    Header: () => 'Expenditure',
    accessor: 'expenditure',
    Cell: ({ row }) => (
      <div className='flex min-w-[120px]'>{row?.original?.expenditure}</div>
    ),
  },
]

export default columns
